import {
    ActionIcon,
    Avatar,
    // Badge,
    Box,
    Burger,
    Button,
    Drawer,
    Group,
    Image,
    // Indicator,
    Paper,
    Stack,
    Text,
    // TextInput,
    Title, rem, Menu,
    Skeleton
} from "@mantine/core";
import CdrLogo from "../../Newlogo/image.png";
import {
    IconArrowLeft
} from "@tabler/icons-react";
import LogoutIcon from '@mui/icons-material/Logout';
import { useState, useEffect } from "react";
import { Userauthcontexthooks } from "../../Hooks/Userauthcontexthooks";
import { message } from 'antd';
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from '@mantine/hooks';




const Newnavbar = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { user, dispatch } = Userauthcontexthooks();
    const [opened, setOpened] = useState(false);
    const [userDetails, SetUserDetails] = useState('');
    const [userProfileloading, SetUserProfileLoading] = useState(true);

    const Logout = () => {
        //closeDrawer();
        message.loading("Please wait, Removing Credentials...", 2);
        setTimeout(() => {
            // Remove the token in Session Storage
            localStorage.removeItem('user');
            localStorage.removeItem('fcmtoken');
            // localStorage.removeItem('expiryTime');
            dispatch({ type: 'LOGOUT' });
            message.success("Successfully Logout");
            setTimeout(() => {
                window.location.href = '/'
            }, 1000);
        }, 2000);
    }
    const navigate = useNavigate();
    const location = useLocation();

    const isHomePage =
        location.pathname === "/v2/home" ||
        location.pathname === "/";

    function Drawer_route_handler(route) {
        navigate(route);
        setOpened(false); // Close the drawer after navigation
    }

    useEffect(() => {
        const GetIndividualUser = async () => {
            const res = await fetch("https://cdr-backend.onrender.com/get/user-details", {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${user}`
                }
            });

            const Result = await res.json();
            if (res.status === 200) {
                SetUserDetails(Result.ExistingUser);
                SetUserProfileLoading(false);
                return
            } else {
                SetUserProfileLoading(false);
                return;
            }
        }
        if (user) {
            GetIndividualUser();
        }
    }, [user])
    return (
        <>
            <Box
                style={{
                    position: "absolute",
                    width: 400,
                    height: 400,
                    borderRadius: "50%",
                    background: "rgba(168,85,247,0.15)",
                    filter: "blur(120px)",
                    bottom: -100,
                    left: -100,
                }}
            />

            {/* MOBILE DRAWER */}
            <Drawer
                opened={opened}
                onClose={() => setOpened(false)}
                title="Court Date Reminder"
                size="75%"
                radius="md"
                styles={{
                    content: {
                        background: "#0f172a",
                    },
                    header: {
                        background: "#0f172a",
                    },
                    title: {
                        color: "white",
                        fontWeight: 700,
                    },
                }}
            >
                <Stack mt="xl">
                    <Button variant="subtle" color="gray" justify="flex-start" onClick={() => Drawer_route_handler('/')}>
                        Home
                    </Button>

                    <Button variant="subtle" color="gray" justify="flex-start" onClick={() => Drawer_route_handler('/cdr/alert-history')}>
                        Alert History
                    </Button>

                    <Button variant="subtle" color="gray" justify="flex-start" onClick={() => Drawer_route_handler('/cdr/about')}>
                        About Us
                    </Button>

                    <Button variant="subtle" color="gray" justify="flex-start" onClick={() => Drawer_route_handler('/v2/profile')}>
                        Profile
                    </Button>
                    <Button variant="subtle" color="gray" justify="flex-start" onClick={() => Drawer_route_handler('/v2/view-all-legal-professionals')}>
                        Professionals Details
                    </Button>
                    <Button variant="subtle" color="gray" justify="flex-start" onClick={() => Drawer_route_handler('/v2/view-all-legal-updates')}>
                        Legal Updates
                    </Button>
                    <Button variant="subtle" color="gray" justify="flex-start" onClick={() => Drawer_route_handler('/v2/feedback-support')}>
                        Support & Feedback
                    </Button>
                </Stack>
            </Drawer>

            {/* HEADER */}
            <Paper
                radius="30px"
                p="md"
                mb="xl"
                style={{
                    background: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    backdropFilter: "blur(20px)",
                }}
            >
                <Skeleton visible={userProfileloading} height={'auto'} radius={'30px'} style={{
                    background: "transparent",
                }}>
                    <Group justify="space-between">
                        {/* LEFT */}
                        {/* <Group>
                        <Burger
                            hiddenFrom="md"
                            opened={opened}
                            onClick={() => setOpened(!opened)}
                            color="white"
                        />

                        <Image
                            src={CdrLogo}
                            w={55}
                            h={55}
                            radius="100%"
                            fit="contain"
                        />

                        <Stack gap={0}>
                            <Text c="#94a3b8" size="sm">
                                Welcome Back 👋
                            </Text>

                            <Title
                                order={3}
                                style={{
                                    color: "white",
                                }}
                            >
                                {userDetails?.Fullname}
                            </Title>
                        </Stack>
                    </Group> */}

                        <Group>
                            {(!isHomePage && !isMobile) && (
                                <ActionIcon
                                    size={45}
                                    radius="xl"
                                    variant="gradient"
                                    gradient={{ from: "blue", to: "cyan" }}
                                    onClick={() => navigate(-1)}
                                    style={{
                                        boxShadow: "0 8px 20px rgba(59,130,246,0.35)",
                                    }}
                                >
                                    <IconArrowLeft size={22} />
                                </ActionIcon>
                            )}
                            <Burger
                                hiddenFrom="md"
                                opened={opened}
                                onClick={() => setOpened(!opened)}
                                color="white"
                            />
                            <Group>
                                <Image
                                    src={CdrLogo}
                                    w={55}
                                    h={55}
                                    radius="100%"
                                    fit="contain"
                                />

                            </Group>

                            <Stack gap={0}>
                                <Text c="#94a3b8" size="sm">
                                    Welcome Back 👋
                                </Text>

                                <Title
                                    order={3}
                                    c="white"
                                >
                                    {userDetails?.Fullname}
                                </Title>
                            </Stack>

                        </Group>



                        {/* RIGHT */}
                        <Group>
                            {/* <ActionIcon
                            variant="light"
                            radius="xl"
                            size={45}
                            color="gray"
                        >
                            <IconMoon size={20} />
                        </ActionIcon> */}

                            {/* <Indicator color="red" size={8}>
                            <ActionIcon
                                variant="light"
                                radius="xl"
                                size={45}
                                color="gray"
                            >
                                <IconBell size={20} />
                            </ActionIcon>
                        </Indicator> */}
                            {(!isHomePage && isMobile) && (
                                <ActionIcon
                                    size={45}
                                    radius="xl"
                                    variant="gradient"
                                    gradient={{ from: "blue", to: "cyan" }}
                                    onClick={() => navigate(-1)}
                                    style={{
                                        boxShadow: "0 8px 20px rgba(59,130,246,0.35)",
                                    }}
                                >
                                    <IconArrowLeft size={22} />
                                </ActionIcon>
                            )}
                            <Menu shadow="md" width={'auto'}>
                                <Menu.Target>
                                    <Avatar
                                        radius="100%"
                                        size={45}
                                        color="blue"
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        name={userDetails?.Fullname}
                                    >

                                    </Avatar>
                                </Menu.Target>
                                <Menu.Dropdown>
                                    <Menu.Label>Personal Details</Menu.Label>
                                    <Menu.Item>
                                        <Text size="xs">Name.: {userDetails?.Fullname}</Text>
                                        <Text size="xs">Mobile No.: {userDetails?.PhoneNumber}</Text>
                                        <Text size="xs">Email.: {userDetails?.Email}</Text>
                                        <Text size="xs">Acc Type.: {userDetails?.AccountType}</Text>
                                        {/* <Text size="xs">U_ID.: {userDetails._id}</Text> */}
                                    </Menu.Item>
                                    <Menu.Divider />
                                    <Menu.Label>Danger zone</Menu.Label>
                                    <Menu.Item
                                        color="red"
                                        leftSection={<LogoutIcon style={{ width: rem(14), height: rem(14) }} />}
                                        onClick={Logout}
                                    >
                                        Logout
                                    </Menu.Item>
                                </Menu.Dropdown>
                            </Menu>
                        </Group>
                    </Group>
                </Skeleton>
            </Paper>

            {/* SEARCH */}
            {/* <TextInput
                radius="xl"
                size="lg"
                mb="xl"
                placeholder="Search services, advocates, VC links..."
                leftSection={<IconSearch size={20} />}
                styles={{
                    input: {
                        height: 60,
                        background: "rgba(255,255,255,0.08)",
                        border: "1px solid rgba(255,255,255,0.08)",
                        color: "white",
                        backdropFilter: "blur(20px)",
                    },
                }}
            /> */}
        </>
    )
}
export default Newnavbar;